import { Component, OnInit, ViewChild, ElementRef, Input, OnChanges, SimpleChanges, OnDestroy, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
// import * as L from 'leaflet';
import { UntypedFormControl } from '@angular/forms';
import {  MatDialog } from '@angular/material/dialog';
import { MatSidenav } from "@angular/material/sidenav";
import { ShareMapService } from '../share-map.service';
import { ActivatedRoute } from '@angular/router';
import { Globals } from 'src/app/globals';
import { ProtectedModalComponent } from '../protected-modal/protected-modal.component';
import { BaseMapService } from 'projects/lib-map-common/src/lib/base-map.service';
import { AppAnalysisService } from 'src/app/app-analysis-module/app-analysis.service';
import { SpatialOperationService } from 'src/app/_services/spatial-operation.service';
import { ResizeEvent } from 'angular-resizable-element';
// import * as jsPDF from 'jspdf';

import { MaphelperService } from 'src/app/app-analysis-module/maphelper.service';
import * as maplibregl from 'maplibre-gl';
import * as MapboxDraw from '@mapbox/mapbox-gl-draw'
import { DirectMode, SimpleSelectMode, CircleMode, DragCircleMode } from 'mapbox-gl-draw-circle';
import DrawRectangle from 'mapbox-gl-draw-rectangle-mode';
import { CommonServiceService } from 'src/app/common-module/common-service.service';
// import FreehandMode from 'mapbox-gl-draw-freehand-mode';
import { CartographyService } from 'src/app/cartography-module/cartography.service';
import { DataShareServiceService } from 'src/app/gis-creator/gis-creator-services/data-share-service.service';




@Component({
  selector: 'app-share-map',
  templateUrl: './share-map.component.html',
  styleUrls: ['./share-map.component.css']
})

export class ShareMapComponent implements OnInit, OnChanges, OnDestroy,AfterViewInit {

  mode = new UntypedFormControl('over');
  @ViewChild('layerMenu') layerMenu: MatSidenav;
  @ViewChild('shareMapAnalysisSidenav') shareMapAnalysisSidenav: MatSidenav;
  @ViewChild('showInfo') showInfo: MatSidenav;
  @ViewChild('container') container: ElementRef;
  @ViewChild('content') content: ElementRef;
  @ViewChild('closer') closer;
  @ViewChild('printMap') printMap: MatSidenav;
  // @ViewChild('helpTooltipElement',{static:false}) helpTooltipElement: ElementRef;
  // @ViewChild('measureTooltipElement',{static:false}) measureTooltipElement: ElementRef;

  @Output() zoomsearch = new EventEmitter<any>();
  @Output() EmitMap = new EventEmitter<any>();
  @Output() EmitMapLayer = new EventEmitter<any>();
  @Output() emitDraw = new EventEmitter<any>();
  @Output() drawDataEmit = new EventEmitter<any>()
  // @Input() mapId;
  helpTooltipElement;
  measureTooltipElement;
  @Input() enableGhostResize: boolean
  searchLocation = new UntypedFormControl();
  filteredLocations: any;
  @ViewChild("map", { static: true })
  public mapElement: ElementRef;
  appId = 'Rk71WGKfxSbcOkCN8kC4'; // userid - yogeshkhere.ep@gmail.com for here-map
  appCode = 'yZay0qfrFU4wHVD-zHso-w'; // password - Yogesh@123
  private map: any;
  public height: string;
  disableMapClick: boolean = false;
  marker: any;
  maptoolBTN: boolean;
  mapLayerId = [];
  clickButton: boolean;
  shareId: any;
  mapLayers: any;
  @Input() navBarColor: any;
  label: any;
  link: any;
  @Input() highlightColor: any;
  @Input() passwordProtected: any;
  _tileServerUrl: string;
  firstlayer: any;
  secondLayer: any;
  circleDrawer: any;
  rectangleDrawer: any;
  polygonDrawer: any;
  BoundingCordinates: any;
  queryToolLayer: any;
  circleradius: number;
  analysisDraw: any;
  attributes = [];
  @Input() logo: any;
  @Input() navbarData: any;
  @Input() mapTitle: any;
  @Input() mapTitleShowHide: any;
  @Input() navigationHeader: any = '1';
  temporaryLayerLayerId: any;
  temporaryLayerDataId: any;
  temporaryLayerAttribute: any;
  temporaryLayer: any;
  popup: any;
  geometryEditOn: boolean = false;
  @Input() mapTools: any;
  @Input() slidingMenu: any = 1;
  passwordValue: any;
  baseMap: any;
  baseMapLayer: any;
  layerId: string;
  gid: string;
  shareFeatureLayer: any;
  removeSharedFeatureButtonShow: boolean = false;
  legend_on: any;
  legendToggle: any;
  changeRandom;
  layerIconVisible: boolean;
  vectorMarkerLayer: any;

  querySearchData: any;
  selectedQueryLayer: any;
  queryData: boolean = false;
  proximityLayer: any;
  showMaintanaceMessage: boolean;
  maintananceMessage: string;
  drawAnalysis;

  analysisLayer;
  drawEvent: string;

  temporarySource;
  selectedTemplate: string = "deafultTemplate";
  measureToolLayer
  geoJSON_afterMapMovment: any;
  chartList: any;
  @Input() mapIdd: any;
  style: object = {};
  fxLayoutForMap: string;
  fxLayoutForChart: string;
  showSearchBox: boolean = false;
  showMeasurementButton: boolean = false;
  
  @Input() isMapPreview;
  @Input() mapPreviewData;
  isLoggedIn;
  isSharedMap = true;
  OperationResetFromMap: boolean = false;
  
  // drawStyle = new Style({
  //   fill: new Fill({
  //     color: 'rgba(255, 255, 255, 0.2)',
  //   }),
  //   stroke: new Stroke({
  //     color: '#ffcc33',
  //     width: 2,
  //   }),
  //   image: new CircleStyle({
  //     radius: 7,
  //     fill: new Fill({
  //       color: '#ffcc33',
  //     }),
  //   }),
  // })


  mapCarto;
  proximityView;
  proximitySchema;
  printMapbox;
  proximityMultipleLayer: boolean;
  isMapLoading: boolean = false;
  vectorFeatureData = false;
  VectorModal
  EditData: any = {}

  measureToolDraw;
  layerName: any;
  fetchData: any;
  keys1: any;
  IdentityFeatureLayer: any;
  Lklayers: any;
  canShowSlider1: any;
  editInfo: boolean;
  editGeom: boolean;
  draw
  drawData: any;

  public constructor(private http: HttpClient, private ShareMapService: ShareMapService, private AppAnalysisService: AppAnalysisService, 
    private route: ActivatedRoute, private MatDialog: MatDialog, private BaseMapService: BaseMapService,
    private spatialOperationService: SpatialOperationService,
    private mapHelperService: MaphelperService,
    private CommonService: CommonServiceService,
    private cartographyService : CartographyService,
    private dataShareService :DataShareServiceService
  ) {
    // const modes = MapboxDraw.modes;
    
    // modes.draw_rectangle = DrawRectangle;
    // modes.draw_circle = CircleMode;
    // modes.drag_circle = DragCircleMode;
    // modes.direct_select = DirectMode,
    //   modes.simple_select = SimpleSelectMode;
    // modes.draw_freeHand = FreehandMode;
    // this.draw = new MapboxDraw({
    //   displayControlsDefault: false,
    //   userProperties: true,
    //   modes: modes,
    // });

    this.draw = new MapboxDraw({
      displayControlsDefault: false,
      userProperties: true,
      modes: {
        ...MapboxDraw.modes,
        draw_circle  : CircleMode,
        drag_circle  : DragCircleMode,
        direct_select: DirectMode,
        simple_select: SimpleSelectMode
      },
      styles: this.CommonService.DrawStyle,
    });
    this.emitDraw.emit(this.draw)
    this._tileServerUrl = Globals.tileserver;
    this.showMaintanaceMessage = Globals.showMaintanaceMessage
    this.maintananceMessage = Globals.maintananceMessage
    this.height = window.innerHeight + "px";

    this.getPublicIcons()

  }
  


  zoomToFeature(zoom) {
    this.zoomsearch.emit(zoom)
  }

  getPublicIcons() {
    this.cartographyService.getPublicIcon().subscribe(data => {
      if (data.http_code == 200) {
        let iconList = data.data;
        this.dataShareService.sendMarkerIconList(iconList);
      }
    },
      err => {
        console.log('------------------------------>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>> Error in getting gis creator icons', err);
      })
  }

  public ngOnInit() {


    // Check User Login Or Not
    // this.authenticationService.isLoggedIn.subscribe(()=>{
    //   this.isLoggedIn = this.authenticationService.isAuthenticated();
    // });

    // if(!this.isLoggedIn){
    //     console.log("logIn nah H");
    //     const dialogRef=this.MatDialog.open(LoginSignupModalComponent,{
    //       width:'75%',
    //       data:{loginModel:true}
    //     });
    //     dialogRef.afterClosed().subscribe(data=>{
    //       if(data){
    //       if(this.isLoggedIn){
    //         let location = window.location.href;
    //         console.log(location);
    //         window.open(location);

    //       }
    //     }
    //     });
    // }



    

    

    // this.baseMapLayer = new Tile({
    //   source: new OSM(),
    // });


    this.mapCarto = this.mapHelperService.initMap('map');
    this.shareId = this.route.snapshot.paramMap.get('share_map_id')
    this.layerId = this.route.snapshot.paramMap.get('layerid')
    this.gid = this.route.snapshot.paramMap.get('gid')
    console.log(' params recived -------->', this.shareId, this.layerId, this.gid);
    // Add zoom controls to the map.
    this.mapCarto.addControl(new maplibregl.NavigationControl({ showCompass: true }), 'bottom-left');
    this.mapCarto.addControl(this.draw)
    this.EmitMap.emit(this.mapCarto)
    this.emitDraw.emit(this.draw)



    if (this.isMapPreview == "1") {
      this.getMapDetails()
      console.log(this.mapPreviewData);
      if (this.mapPreviewData.data) {
        this.listAllLayerOfMap(this.mapPreviewData.data)
      }

    }
    else {
      this.GetShareModeOn()
    }

    this.isMapLoading = true;
    this.mapCarto.on('zoom', () => {
      setTimeout(() => {
        this.isMapLoading = true;
      }, 500);//
    });
    this.mapCarto.on('dragPan', () => { this.isMapLoading = true; this.mapCarto.resize() });
    this.mapCarto.on('idle', (e) => { this.isMapLoading = false; this.mapCarto.resize() });



    //Raster Identity Fature
    // this.mapCarto.on('click',(e)=>{
    //   console.log("wmns layer show");
    //   this.isMapLoading = true;
    //   this.mapHelperService.getFeatureInfo(this.mapCarto, e, this.mapLayers).then((result)=>{
    //     if(result){
    //       console.log(result)
    //       this.showInfo.open();  
    //       this.content.nativeElement.innerHTML = result;
    //     }else{
    //       this.showInfo.close();
    //     }
    //     this.isMapLoading = false;
    //   })

    //  } 

    // )

    this.mapCarto.on('click', (e) => {
      this.isMapLoading = true;
      // this.content.nativeElement.innerHTML = ""
      // this.showInfo.close();
      //Identity Feature For Raster Layers
      this.mapHelperService.getFeatureInfo(this.mapCarto, e, this.mapLayers).then((result: any[]) => {
        if (result) {
          this.layerName = result[0].layer_name
          this.fetchData = result[3]
          this.keys1 = result[1]

          this.IdentityFeatureLayer = result[0]
          this.Lklayers = result[2]

          this.showInfo.open();

          // this.content.nativeElement.innerHTML += result;
          // this.info = `"${this.content.nativeElement.innerHTML}"`



        } else {
          if (!this.vectorFeatureData) {
            this.showInfo.close();
            // this.content.nativeElement.innerHTML = ""
          }
        }
        this.isMapLoading = false;
      })
    })


    //Identity Feature For Vector Layers
    this.VectorModal = this.mapHelperService.VectorFeatureModal.subscribe(data => {
      if (Array.isArray(data)) {
        // if(this.canShowSlider1){
        this.showInfo.open();
        // }
        this.layerName = data[0].layer_name
        this.fetchData = data[3]
        this.keys1 = data[1]
        this.IdentityFeatureLayer = data[0]
        this.IdentityFeatureLayer['geometry'] = data[4]


        this.Lklayers = data[2]
      }
      else {
        console.log(data)
        // this.content.nativeElement.innerHTML = ""
        if (data[0]) {
          // if(this.canShowSlider1){
          this.showInfo.open();
          // }
          this.layerName = data[0].layer_name
          this.fetchData = data[3]
          this.keys1 = data[1]

          this.Lklayers = data[2]
          // this.content.nativeElement.innerHTML += data["content"];
          this.vectorFeatureData = true;
          return
        } else {
          this.showInfo.close();
          // this.content.nativeElement.innerHTML = "";
        }
      }
    })


  }

  ngAfterViewInit(): void {
    setTimeout(()=>{
      this.map.on('idle', (e) => { this.map.resize() });
    },500)


  }

  getMapDetails() {
    this.AppAnalysisService.getMapDetail(this.shareId).subscribe(data => {
      let basemap = data["data"][0].base_map;
      this.checkBaseMap(basemap)
      // this.mapTitle = this.mapName;
    });
  }

  getDrawData(drawData) {
    console.warn(drawData)
    this.drawData = drawData
    this.drawDataEmit.emit(this.drawData)
  }

  clearemit(data){
if(data){

}
  }

  layerLoader = false;
  FirstLoadPreviewData = false
  ngOnChanges(changes: SimpleChanges) {
    console.log("This is the map Preview Data", this.mapPreviewData)
    if (this.mapPreviewData.data) {
      this.listAllLayerOfMap(this.mapPreviewData.data, this.FirstLoadPreviewData)
      this.FirstLoadPreviewData = true
    } else {
      // this.layerLoader = true;

    }
    // if(this.mapPreviewData == undefined){
    //   this.layerLoader = true;
    // }
    // else{
    //   this.listAllLayerOfMap(this.mapPreviewData.data) 
    // }

  }

  // On Share Map DetailsData
  GetShareModeOn() {
    this.ShareMapService.getShareMapMode(this.shareId).subscribe(data => {
      if (data.data.share_mode == 'PROTECTED') {
        let ModalData = {
          "shareId": this.shareId,
          "shareMode": data.data.share_mode
        }
        let dialogRef = this.MatDialog.open(ProtectedModalComponent, {
          width: 'auto',
          data: ModalData,
        });
        dialogRef.afterClosed().subscribe(result => {
          // this.data = result
          this.shareMapOperation(result)
          this.listAllLayerOfMap(result.data.layer_details)
          let baseMapName = result.data.share_details.base_map;
          this.checkBaseMap(baseMapName)
        });
      }
      else if (data.data.share_mode == 'PRIVATE') {
        let ModalData = {
          "shareId": this.shareId,
          "shareMode": data.data.share_mode
        }
        this.AppAnalysisService.getPrivateShareMapDetails(this.shareId, null).subscribe(data => {
          if (data.http_code == 403) {
            let dialogRef = this.MatDialog.open(ProtectedModalComponent, {
              width: 'auto',
              data: ModalData
            });
          }
          else {
            this.shareMapOperation(data)
            this.listAllLayerOfMap(data.data.layer_details)
            let baseMapName = data.data.share_details.base_map;
            this.checkBaseMap(baseMapName)
          }
        });
      }
      else {
        this.ShareMapService.getShareMapDetails(this.shareId, null).subscribe(data1 => {
          console.log('----------share map datatatatat ----->', data1);
          this.shareMapOperation(data1)
          this.listAllLayerOfMap(data1.data.layer_details);

          let baseMapName = data1.data.share_details.base_map;
          this.checkBaseMap(baseMapName)

        });
      }
    });
  }

  checkBaseMap(baseMapName) {
    if (baseMapName) {
      // this.currentBaseMap = baseMapName;
      let baseMapList = this.BaseMapService.baseMapList;
      let index = baseMapList.findIndex(a => a.name == baseMapName);
      if (index >= 0) {
        this.changeBaseMap(baseMapList[index]);
      }
    }
  }




  removeAnalysisLayer() {
    this.drawStarted = false;
    //for removing the feature layer recived from api
    this.BoundingCordinates = undefined;
    if (this.analysisLayer) {
      this.map.removeLayer(this.analysisLayer);
    }
    if (this.proximityLayer) {
      this.map.removeLayer(this.proximityLayer);
    }
    if (this.queryToolLayer) {
      this.map.removeLayer(this.queryToolLayer);
    }
    this.disableMapClick = false;
    this.map.removeInteraction(this.drawAnalysis);
  }
  drawStarted: boolean = false;

  resultLayerName;
  totalResultSearch;


  markerPopup
  // Geo Auto Location Search and Marker Add
  recieveSearchData(location) {

    if (location) {
      let sw = new maplibregl.LngLat(location.Longitude, location.Latitude);
      let ne = new maplibregl.LngLat(location.Longitude, location.Latitude);
      let llb = new maplibregl.LngLatBounds(sw, ne);
      this.mapCarto.fitBounds(llb);

      // this.markerPopup = new maplibregl.Popup({ offset: 25 }).setHTML(`<div class="marker-remove"></div>`) 
      // Create Marker obj 
      // var marker1 = new maplibregl.Marker()
      //   .setLngLat([location.Longitude,location.Latitude])
      //   .addTo(this.mapCarto)

      // this.mapCarto.on('click',(e)=>{
      //   console.log("on marker clicked")
      //   if(e.originalEvent.target !== marker1.getElement()){
      //     marker1.remove()
      //   }
      // });

    }

  }

  toggleLayerMenu(event) {
    if (event === 'close') {
      this.layerMenu.close();
      this.maptoolBTN = false;
    }
    else {
      this.layerMenu.open();
      this.maptoolBTN = true;
    }
    console.log('gggg', this.maptoolBTN);
  }



  // Switch Condition for Analysis and Query Tools
  componentName = "";
  querytool;
  ShareMapToolBtn(event) {
    this.shareMapAnalysisSidenav.open();
    this.componentName = event;
    switch (event) {
      case 'proximityAnalysis':
        this.querytool = false;
        break;
      case 'queryAnalysis':
        this.querytool = true;
        break;
    }

  }
  closeShareMapAnalysisSideNav() {
    this.shareMapAnalysisSidenav.close();
    this.printMap.close();
  }


  TogglePrintBox(event) {
    this.printBox = !this.printBox;
    console.log("close print")
  }
  //#End

  shareMapOperation(data) {
    let shareDetails = data.data.share_details
    this.mapTools = shareDetails.map_tools
    this.slidingMenu = shareDetails.menu_slider
    this.navBarColor = shareDetails.navbar_color
    this.navbarData = JSON.parse(JSON.parse(shareDetails.navbar_data))
    this.highlightColor = shareDetails.highlight_color
    this.mapTitle = shareDetails.map_title
    this.navigationHeader = shareDetails.nav_header
    this.mapTitleShowHide = shareDetails.map_title_on
    this.logo = shareDetails.icon_path
    this.passwordProtected = shareDetails.share_mode
    this.baseMap = shareDetails.base_map
    this.mapIdd = shareDetails.mapidd
  }


  listAllLayerOfMap(data, isFirstload = false) {
    // data.data.layer_details
    if (!isFirstload) {
      this.layerLoader = true;
      this.mapHelperService.onAddLayer(data, this.mapCarto).then(
        (result) => {
          this.layerLoader = false;
          console.log("this is maplayers    ", this.mapLayers)
          try{
            this.mapCarto.fitBounds(result["extent"]);          
          }catch{}

          this.mapLayers = result["maplayers"];
          this.mapCarto = result["map"];
          this.EmitMapLayer.emit(this.mapLayers)

          // this.AppAnalysisService.getAllLayersOfTerritory(this.mapIdd)
          //   .subscribe(
          //     data => {
          //       console.log("layer Load", data);
          //       if (data.data == false && data.status == "FAIL") {
          //       }
          //       else {
          //         console.warn(data.data)
          //         let dummyMapLayer = data.data.data
          //         let newlayers = dummyMapLayer.filter(val => {
          //           if (val.added_from != "REFERENCE_TERRITORY") {
          //             return val
          //           }
          //         })

          //         let UpdateTerritoryData = []
          //         if (newlayers.length > 1) {
          //           if (newlayers[0].layer_type == 'POLYGON') {
          //             UpdateTerritoryData = newlayers
          //           } else {
          //             UpdateTerritoryData.push(newlayers[1])
          //             UpdateTerritoryData.push(newlayers[0])
          //           }
          //         } else {
          //           UpdateTerritoryData = newlayers
          //         }
          //         this.SetTerritoryLayersType(UpdateTerritoryData)

          //       }
          //     })
            })

        }

    }

    public addLayerOnMapLayer(uploadedLayer, mapTour) {

      this.mapHelperService.getLayerJsonData(uploadedLayer.dbzxvuwyacs, uploadedLayer.drpnlkmoqt).subscribe(data => {
      })

    this.mapHelperService.onAddLayer(uploadedLayer, this.mapCarto).then(
      (result) => {
        console.log(result)
        let x = result;
        for (let i = 0; i < result["maplayers"].length; i++) {
          this.mapLayers.push(result["maplayers"][i]);
        }
        console.log(this.mapLayers)
        this.mapCarto.fitBounds(result["extent"]);
        this.mapCarto = result["map"];
        // this.SetTerritoryLayersType(this.mapLayers)
      },
      (error) => {
        console.log("error on map", error);
      }
    )
  }
  GetTerritoryLayerDetails(){
    this.mapLayers.forEach((element, i) => {
      console.log(element);
      if (element.layer_type == "POLYGON") {
        this.TerritoryLayer = this.mapLayers[i];
        this.TerritoryLayer['index'] = i
      }
    });
  }

  Tooglebox = 'assign_users'
  toogleSection(value) {
    this.Tooglebox = value
  }

  setStyleDetailsInMapLayers(layerid, styleDetails) {
    let index = this.mapLayers.findIndex((a) => a.layerid == layerid);
    this.mapLayers[index].style_details = styleDetails
  }

  TurnOffAndOnLayer(LayerId) {
    // this.mapHelperService.removeLayerFromMap(this.mapCarto, this.mapLayers[0].identity, this.mapLayers[0].multiple)
    // this.mapHelperService.removeLayerFromMap(this.mapCarto, this.mapLayers[1].identity, this.mapLayers[1].multiple)

    // this.AppAnalysisService.getAllLayersOfMap(this.mapIdd).subscribe(data => {
      // this.listAllLayerOfMap(data.data);
      // this.mapLayers = data.data
    
    let index1 = this.mapLayers.findIndex((a) => a.layerid == LayerId);
    let identity = this.mapLayers[index1].identity
    let multiple = this.mapLayers[index1].multiple
    let layer = this.mapLayers[index1]

    this.turnOffLayer(identity, multiple, index1)
    setTimeout(() => {
      this.turnOnLayer(layer, index1)
    }, 500);//
  // })
  }

  BusinessLayerDetails: any = false
  TerritoryLayerDetails: any = false
  SubLayerData
  SetTerritoryLayersType(maplayers) {
    maplayers.forEach(element => {
      element.subuser_layers_data.forEach((element2,index) =>{
      
      if(element.subuser_layers_data[index].style_details==false){
      let index1 = this.mapLayers.findIndex((a) => a.layerid == element.subuser_layers_data[index].layerid);
      element.subuser_layers_data[index].style_details = this.mapLayers[index1].style_details
      }
    })
      if (element.layer_type == "POLYGON" && element.added_from == "TERRITORY") {
        this.TerritoryLayerDetails = element
        if(element.subuser_layers_data.length >0){
          this.SubLayerData = element.subuser_layers_data
        }
        // this.TerritoryCommonService.TerritoryToolsEnableServiceFn(this.TerritoryLayerDetails)
        // this.setFitBound(this.TerritoryLayerDetails)

      }
      if (element.layer_type == "POINT" && element.added_from != "REFERENCE_TERRITORY") {
        this.BusinessLayerDetails = element
      }
    });
  }

  CheckUnassignedArea(subuser){
    let key = Object.keys(subuser)
    if(key.includes("unassigned_area")){
      return true
    }
    return false 
}

  getUserStyles(layer) {
    try{
      let style_att = JSON.parse(layer.style_details.style_attributes)
      let custom_legend = JSON.parse(style_att.custom_legend)
      let obj = {}
      custom_legend.forEach(val => {
        if (val.value === layer.username) {
          obj = { 'background-color': val.color }
        }
      })
      return obj
    }
    catch{
      return null
    }

  }

  TerritoryLayer
  ShowSubLayer(sublayer,index){
    console.log(sublayer)
    // this.AddSubLayerOnMap(sublayer,index)
    this.mapHelperService.onAddLayer([sublayer],this.mapCarto);
    this.GetTerritoryLayerDetails()
    this.turnOffLayer(this.TerritoryLayer,this.TerritoryLayer.multiple,this.TerritoryLayer.index)

    this.SubLayerData[index].isSubLayerVisible = true;
  }


  HideSubLayer(sublayer,index){
    this.mapHelperService.removeLayerFromMap(this.mapCarto, sublayer.identity,false)
    this.SubLayerData[index].isSubLayerVisible = false

  }

  ZoomToUsers(layer_bbox){

    let bbox = JSON.parse(layer_bbox)
    let extentArray: any = [bbox.minx, bbox.miny, bbox.maxx, bbox.maxy];
    this.mapCarto.fitBounds(extentArray)
  }


  changeBaseMap(event) {
    if (this.baseMapLayer) {
      this.mapHelperService.removeLayerFromMap(this.mapCarto, this.baseMapLayer, false);
    }
    else {
      this.mapHelperService.removeLayerFromMap(this.mapCarto, 'open street map', false);
    }
    let layersList = this.mapCarto.getStyle().layers;
    this.baseMapLayer = event.name;
    if (event.name != "Empty") {
      this.baseMapLayer = event.name;
      this.mapCarto.addSource(event.name, event.source)
      if (layersList.length > 0)
        this.mapCarto.addLayer({ id: event.name, type: 'raster', source: event.name }, layersList[0].id);
      else
        this.mapCarto.addLayer({ id: event.name, type: 'raster', source: event.name });
    }
  }

  turnOffLayer(identity, multiple, index) {
    this.mapHelperService.removeLayerFromMap(this.mapCarto, identity, multiple)
    this.mapLayers[index].isLayerVisible = false;
    this.visibilityLoader[index]=false
  }

  visibilityLoader = {};
  turnOnLayer(layer, index) {
    this.visibilityLoader = {}
    this.visibilityLoader[index] = true;
    // this.mapHelperService.getLayerJsonData(dbzxvuwyacs,drpnlkmoqt).subscribe(data => {
      if(!layer.dbzxvuwyacs){
        layer.dbzxvuwyacs = layer.dbzxvuwyacs
      }
    let layerMapDetails = this.mapHelperService.addLayers(layer.dbzxvuwyacs + "." + layer.drpnlkmoqt, layer.db_layer_type, layer.wmslayerurl, this.mapCarto, layer.raster_on, "blue", layer);
    this.mapCarto = layerMapDetails.map;
    this.mapLayers[index].isLayerVisible = true;
    let gtype = layer.db_layer_type.replace("MULTI", "");
    this.mapHelperService.setMapStyle(this.mapLayers[index].style_details, gtype, this.mapLayers[index].identity, this.mapCarto, this.mapLayers[index].multiple);

    this.visibilityLoader[index] = false;
    // },err =>{this.visibilityLoader[index] = false;});
  }


  zoomToLayer(fitbounds) {
    this.mapCarto.fitBounds(fitbounds);
  }


  legendToggleOnButton(layerid) {
    this.legendToggle = '1'
    this.legendRefresh(layerid)
    console.log(layerid);

  }

  legendToggleOffButton(layerid) {
    this.legendToggle = '0'
    this.legendRefresh(layerid)
  }

  legendRefresh(layerid) {
    console.log('layer id =---------->', layerid);
    let indexlabelLayer = this.mapLayers.findIndex(a => a.layerid == layerid);
    this.mapLayers[indexlabelLayer].legend_on = this.legendToggle;
    this.changeRandom = new Date();
  }

  bearingRefresh(layerid) {
    console.log('layer id =---------->', layerid);
    let indexlabelLayer = this.mapLayers.findIndex(a => a.layerid == layerid);
    this.mapLayers[indexlabelLayer].legend_on = this.legendToggle;
    this.changeRandom = new Date();
  }

  bearingToggleOn(layerid) {
    this.legendToggle = '1'
    this.bearingRefresh(layerid)
    console.log(layerid);

  }

  bearingToggleOff(layerid) {
    this.legendToggle = '0'
    this.bearingRefresh(layerid)
  }




  menubar: boolean = false;
  menuToggle() {
    this.menubar = !this.menubar;
  }

  btnLoader = false
  downloadQuerySearchData() {
    // this.CsvFileDownloadService.createDownloadableCsvFromGeojson(JSON.parse(this.querySearchData));
    this.btnLoader = true;
    this.AppAnalysisService.downloadExcelOperationFileSharedMap(this.proximitySchema, this.proximityView).subscribe(val => {
      this.btnLoader = false;
      if (val.http_code == 200) {
        window.open(val.data);
      }
    });
  }


  onResetButton() { // for query tool reset button 
    this.OperationResetFromMap = true;
    this.selectedQueryLayer = undefined;
    this.mapHelperService.removeLayerFromMap(this.mapCarto, this.proximityLayer, this.proximityMultipleLayer);
    this.queryData = false;

    // this.removeAnalysisLayer();
  }

  closeLayerTypeSideNav() {
    this.showInfo.close()
  }

  getAllChartsData(bounding_coordinates) {
    this.AppAnalysisService.getAllChartValues(this.mapIdd, bounding_coordinates).subscribe(data => {
      if (data.data) {
        this.chartList = data.data
      } else {
        this.chartList = [];
      }
    })
  }

  proximityOperationGeometry(data) {
    this.mapHelperService.ListenMapPopup.next(true);
    this.showInfo.close();
    if (!data) {
      //AKSHAY :  *** We need to provide the proper message in toast that no data was found
    }
    this.totalResultSearch = data.feature_count;
    this.proximityLayer = data.proximityLayer;
    this.queryData = true;
    this.selectedQueryLayer = data.selectedLayer
    this.proximitySchema = data.dbzxvuwyacs;
    this.proximityMultipleLayer = data.isMultiple;
    this.proximityView = data.view;
    this.closeShareMapAnalysisSideNav();
    // this.analysisSidenav.close();
  }

  onResizeEnd(event: ResizeEvent): void {
    console.log('Element was resized', event);
    this.style = {
      left: `${event.rectangle.left}px`,
      top: `${event.rectangle.top}px`,
      width: `${event.rectangle.width}px`,
      height: `${event.rectangle.height}px`
    };
    setTimeout(() => {
      this.map.updateSize();
    }, 200);
  }
  searchBox() {
    this.showSearchBox = !this.showSearchBox;
    // this.map.removeLayer(this.vectorMarkerLayer)
  }
  printBox: boolean = false;
  printMapButton() {
    this.printBox = !this.printBox;
    console.log("print is called");
    let abc = this.printMapbox;
  }

  printOfMap(selectedFormat) {
    var format = "a4";
    var resolution = 72;
    var dim = [297, 210];
    var width = Math.round(dim[0] * resolution / 25.4);
    var height = Math.round(dim[1] * resolution / 25.4);
    var size = this.map.getSize();
    var viewResolution = this.map.getView().getResolution();

    this.map.once('rendercomplete', () => {
      var mapCanvas = document.createElement('canvas');
      mapCanvas.width = width;
      mapCanvas.height = height;
      var mapContext = mapCanvas.getContext('2d');
      Array.prototype.forEach.call(document.querySelectorAll('.ol-layer canvas'), function (canvas) {
        if (canvas.width > 0) {
          var opacity = canvas.parentNode.style.opacity;
          mapContext.globalAlpha = opacity === '' ? 1 : Number(opacity);
          var transform = canvas.style.transform;
          // Get the transform parameters from the style's transform matrix
          var matrix = transform.match(/^matrix\(([^\(]*)\)$/)[1].split(',').map(Number);
          // Apply the transform to the export map context
          CanvasRenderingContext2D.prototype.setTransform.apply(mapContext, matrix);
          mapContext.drawImage(canvas, 0, 0);
        }
      });
      if (selectedFormat == "pdf") {
        //   var pdf = new jsPDF('landscape', undefined, format);
        //   pdf.addImage(
        //     mapCanvas.toDataURL('igismap/jpeg'),
        //     'JPEG',
        //     0,
        //     0,
        //     dim[0],
        //     dim[1]
        //   );
        //   pdf.save('map.pdf');
        //   // Reset original map size
        // var pdf = new jsPDF('landscape', undefined, format);
        // pdf.addImage(mapCanvas.toDataURL('image/jpeg'), 'JPEG', 0, 0, dim[0], dim[1]);
        // pdf.save('map.pdf');
      }
      else {
        let image = mapCanvas.toDataURL('image/jpeg').replace("image/jpeg", "image/octet-stream");;
        let link = document.createElement("a");
        link.download = "igismap.jpeg";
        link.href = image;
        link.click();
        // window.location.href = image;
      }
      // Reset original map size
      this.map.setSize(size);
      this.map.getView().setResolution(viewResolution);
      // exportButton.disabled = false;
      // document.body.style.cursor = 'auto';
    });

    // Set print size
    var printSize = [width, height];
    this.map.setSize(printSize);
    var scaling = Math.min(width / size[0], height / size[1]);
    this.map.getView().setResolution(viewResolution / scaling);

    // }

  }

  // vectorLayerStyle = new Style({
  //   fill: new Fill({
  //     color: 'rgba(255, 255, 255, 0.2)',
  //   }),
  //   stroke: new Stroke({
  //     color: '#ffcc33',
  //     width: 2,
  //   }),
  //   image: new CircleStyle({
  //     radius: 7,
  //     fill: new Fill({
  //       color: '#ffcc33',
  //     }),
  //   }),
  // })

  measurementTool(buttonType) {
    // if(this.measureToolLayer){
    //   this.map1.removeLayer(this.measureToolLayer)
    // }
    this.showMeasurementButton = true
    let sketch; //Currently drawn feature.
    let continuePolygonMsg = 'Click to continue drawing the polygon or double click the last point to stop';
    var continueLineMsg = 'Click to continue drawing the line or double click the last point to stop';
    this.createMeasureTooltip('bottom-center');
    this.createHelpTooltip('center-left');


    let pointerMoveHandler = (evt) => {
      if (evt.dragging) {
        return;
      }

      var helpMsg = 'Click to start drawing';

      if (sketch) {
        var geom = sketch.getGeometry();
      }

      this.helpTooltipElement.innerHTML = helpMsg;
      // this.helpTooltip.setPosition(evt.coordinate);
      this.helpTooltipElement.classList.remove('hidden');


    };


    this.map.on('pointermove', pointerMoveHandler);

    this.map.getViewport().addEventListener('mouseout', () => {
      this.helpTooltipElement.classList.add('hidden');
    });

    // var formatLength = (line) => {
    //   var length = getLength(line);
    //   var output;
    //   if (length > 100) {
    //     output = Math.round((length / 1000) * 100) / 100 + ' ' + 'km';
    //   } else {
    //     output = Math.round(length * 100) / 100 + ' ' + 'm';
    //   }
    //   return output;
    // };

    // var formatArea = (polygon) => {
    //   var area = getArea(polygon);
    //   var output;
    //   if (area > 10000) {
    //     output = Math.round((area / 1000000) * 100) / 100 + ' ' + 'km<sup>2</sup>';
    //   } else {
    //     output = Math.round(area * 100) / 100 + ' ' + 'm<sup>2</sup>';
    //   }
    //   return output;
    // };

    // this.measureToolSource = new VectorSource();

    // this.measureToolLayer = new VectorLayer({
    //   source: this.measureToolSource,
    //   style: this.vectorLayerStyle
    // });


    // this.measureToolDraw = new Draw({
    //   source: this.measureToolSource,
    //   type: buttonType,
    // });

    let listener;
    this.measureToolDraw.on('drawstart', (evt) => {
      // set sketch
      sketch = evt.feature;

      /** @type {import("../src/ol/coordinate.js").Coordinate|undefined} */
      var tooltipCoord = evt.coordinate;

      listener = sketch.getGeometry().on('change', (evt) => {
        var geom = evt.target;
        var output;
        // if (geom instanceof Polygon) {
        //   output = formatArea(geom);
        //   tooltipCoord = geom.getInteriorPoint().getCoordinates();
        // } else if (geom instanceof LineString) {
        //   output = formatLength(geom);
        //   tooltipCoord = geom.getLastCoordinate();
        // }
        // this.measureTooltipElement.innerHTML = output;
        // this.measureTooltip.setPosition(tooltipCoord);
      });
    });

    this.measureToolDraw.on('drawend', () => {
      this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-static';
      // this.measureTooltip.setOffset([0, -7]);
      // unset sketch
      sketch = null;
      // unset tooltip so that a new one can be created
      // this.measureTooltipElement = null;
      // this.createMeasureTooltip('bottom-center');
      // unByKey(listener);

      this.map.removeInteraction(this.measureToolDraw)
      // this.map.removeOverlay(this.helpTooltip)
      // this.map1.removeOverlay(this.measureTooltip)
    });
    // }
    this.map.addInteraction(this.measureToolDraw);
    this.map.addLayer(this.measureToolLayer)
  }

  createHelpTooltip(position) {
    // if (helpTooltipElement) {
    //   helpTooltipElement.parentNode.removeChild(helpTooltipElement);
    // }
    // helpTooltipElement = document.createElement('div');
    // helpTooltipElement.className = 'ol-tooltip hidden';

    if (this.helpTooltipElement) {
      this.helpTooltipElement.parentNode.removeChild(this.helpTooltipElement);
      // this.helpTooltipElement = null;
    }
    this.helpTooltipElement = document.createElement('div');
    this.helpTooltipElement.className = 'ol-tooltip hidden';
    // this.helpTooltip = new Overlay({
    //   element: this.helpTooltipElement,
    //   offset: [15, 0],
    //   positioning: position,
    // });
    // this.map.addOverlay(this.helpTooltip);
  }

  createMeasureTooltip(position) {
    // if (this.measureTooltipElement) {
    //   this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    //   // this.measureTooltipElement.nativeElement = null;
    // }
    this.measureTooltipElement = document.createElement('div');
    this.measureTooltipElement.className = 'ol-tooltip ol-tooltip-measure';
    // this.measureTooltip = new Overlay({
    //   element: this.measureTooltipElement,
    //   offset: [0, -15],
    //   positioning: position,
    // });
    // this.map.addOverlay(this.measureTooltip);
  }

  clearMeasureMent() {
    this.showMeasurementButton = false
    this.map.removeLayer(this.measureToolLayer)
    this.measureTooltipElement.parentNode.removeChild(this.measureTooltipElement);
    this.measureTooltipElement = null;
    this.measureToolDraw.clear()
    // this.map.removeOverlay(this.helpTooltip)
    // this.map.removeOverlay(this.measureTooltip)
  }


  WindowCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            Latitude: position.coords.latitude,
            Longitude: position.coords.longitude,
          };
          this.recieveSearchData(pos);
        },
        (err) => {
          this.handleLocationError(err);
        }
      );
    } else {
      // Browser doesn't support Geolocation
      alert("Browser doesn't support Geolocation")
    }
  }

  handleLocationError(value) {
    console.log(value)
  }


  ngOnDestroy() {
    if (this.VectorModal) {
      this.VectorModal.unsubscribe()
    }

  }
}


